module.exports = __webpack_public_path__ + "media/npc_dota_hero_grimstroke.f43f01b0.webm";